import mixitup from 'mixitup';

export class Filter {
    constructor ( target = '.js-filter', options = {} ) {

        this.target = target;

        this.options = {
            ...options
        }
    }

    init () {
        this.$container = document.querySelector( this.target );
        if(!this.$container) {
            return false;
        }
        var mixer = mixitup(this.$container);
    }

}
